import React from 'react';
import PropTypes from 'prop-types';

import { xingConnect } from '@xingternal/frame-data-provider';
import { LayoutClassic } from '@xingternal/platform-layout-classic';
import { LayoutMain } from '@xingternal/platform-layout-main';

import selectXingView from './selectors';

const XingView = ({ armstrongV1, children, ...props }) => {
  const LayoutComponent = armstrongV1 ? LayoutMain : LayoutClassic;

  return <LayoutComponent {...props}>{children}</LayoutComponent>;
};

XingView.propTypes = {
  children: PropTypes.node,
  // XingConnect
  armstrongV1: PropTypes.bool.isRequired,
};

export default xingConnect(selectXingView)(XingView);
